"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var primitives_1 = require("web/components/primitives");
var style_scss_1 = __importDefault(require("./style.scss"));
var ScrollLoader = function (_a) {
    var children = _a.children, loading = _a.loading, scrollTrigger = _a.scrollTrigger, page = _a.page, _b = _a.renderLockTimeout, renderLockTimeout = _b === void 0 ? 1000 : _b, className = _a.className, loader = _a.loader, isEmpty = _a.isEmpty, resetScroll = _a.resetScroll, _c = _a.emptyText, emptyText = _c === void 0 ? 'No Matching Items Found' : _c, rest = __rest(_a, ["children", "loading", "scrollTrigger", "page", "renderLockTimeout", "className", "loader", "isEmpty", "resetScroll", "emptyText"]);
    var triggerRef = (0, react_1.useRef)(null);
    var containerRef = (0, react_1.useRef)(null);
    var timeRef = (0, react_1.useRef)();
    var _d = (0, react_1.useState)(true), renderLock = _d[0], setRenderLock = _d[1];
    (0, react_1.useEffect)(function () {
        if (resetScroll && containerRef.current) {
            containerRef.current.scrollTo(0, 0);
        }
    }, [resetScroll]);
    (0, react_1.useEffect)(function () {
        // Create an Intersection Observer
        var currentRef = triggerRef.current;
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting) {
                if (!loading && !renderLock && !isEmpty) {
                    if (page) {
                        scrollTrigger(page + 1);
                    }
                    else {
                        scrollTrigger();
                    }
                }
            }
        });
        // Start observing the trigger element
        if (triggerRef.current) {
            observer.observe(triggerRef.current);
        }
        return function () {
            // Cleanup observer when unmounting
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading, scrollTrigger, page, triggerRef, renderLock]);
    (0, react_1.useEffect)(function () {
        if (timeRef.current) {
            clearTimeout(timeRef.current);
        }
        timeRef.current = setTimeout(function () { return setRenderLock(false); }, renderLockTimeout);
        setRenderLock(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [children]);
    var renderLoading = function () {
        if (!loader) {
            return (react_1.default.createElement(primitives_1.FlexContainer, { className: style_scss_1.default.loader },
                react_1.default.createElement(primitives_1.FlexContainer, { alignItems: "center", justifyContent: "center", className: style_scss_1.default.loader },
                    react_1.default.createElement(primitives_1.LoadingSpinner, { size: 24 }),
                    react_1.default.createElement(primitives_1.Text, { size: "1.6rem", bold: true, className: style_scss_1.default.p2 }, "Loading..."))));
        }
        else {
            return loader;
        }
    };
    return (react_1.default.createElement(primitives_1.FlexContainer, __assign({ className: (0, classnames_1.default)(style_scss_1.default.container, className), ref: containerRef, keepHeight: true, scroll: true }, rest),
        react_1.default.createElement("div", null, children),
        react_1.default.createElement("div", { ref: triggerRef, style: { width: 10, height: 2 } }),
        loading && !isEmpty && renderLoading(),
        isEmpty && (react_1.default.createElement(primitives_1.EmptyLoadingPlaceholder, { isEmpty: true, isLoading: loading, iconName: primitives_1.IconType.slash, emptyText: emptyText }))));
};
exports.default = ScrollLoader;
